import { applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';

import * as rootReducer from '../reducers';

import me from '../reducers/me';
import meProducts from '../reducers/meProducts';
import repository from '../reducers/repository';
import modals from '../reducers/modals';
import newFolder from '../reducers/newFolder';
import deleteItem from '../reducers/deleteItem';
import toasts from '../reducers/toasts';
import renameItem from '../reducers/renameItem';
import cloneAudience from '../reducers/cloneAudience';
import moveItem from '../reducers/moveItem';
import createAudienceModal from '../reducers/createAudienceModal';
import createTsvModal from '../reducers/createTsvModal';
import queryBuilder from '../reducers/queryBuilder';
import taxonomyList from '../reducers/taxonomyList';
import queryPreview from '../reducers/queryPreview';
import demographicsItems from '../reducers/demographicsItems';
import exploreItems from '../reducers/exploreItems';
import reportErrorModal from '../reducers/reportErrorModal';
import itemDragDrop from '../reducers/itemDragDrop';
import saveAudience from '../reducers/saveAudience';
import tabs from '../reducers/tabs';
import requireMissingItem from '../reducers/requireMissingItem';
import timeframes from '../reducers/timeframes';
import layout from '../reducers/layout';
import conversation from '../reducers/conversation';
import support from '../reducers/support';
import tsv from '../reducers/tsv';

import companies from '../reducers/companies';
import users from '../reducers/users';
import shareQuery from '../reducers/shareQuery';
import fusions from '../reducers/fusions';
import audienceBuilders from '../reducers/audienceBuilders';
import websocket from '../reducers/websocket';
import myCompany from '../reducers/myCompany';

import { storeManager } from './ReducerManager';

import rootSaga from '../sagas';

export const history = createBrowserHistory();

const staticReducers = {
  me,
  meProducts,
  repository,
  modals,
  newFolder,
  deleteItem,
  toasts,
  renameItem,
  cloneAudience,
  moveItem,
  createAudienceModal,
  createTsvModal,
  queryBuilder,
  taxonomyList,
  queryPreview,
  demographicsItems,
  exploreItems,
  reportErrorModal,
  itemDragDrop,
  saveAudience,
  tabs,
  requireMissingItem,
  timeframes,
  layout,
  router: connectRouter(history),
  conversation,
  tsv,
  support,
  companies,
  users,
  fusions,
  audienceBuilders,
  shareQuery,
  websocket,
  myCompany,
};

const configureProductionStore = preloadedState => {
  storeManager.registerReducers(staticReducers);

  const sagaMiddleware = createSagaMiddleware({
    context: {
      lang: 'en-US',
    },
  });

  const middlewares = applyMiddleware(
    sagaMiddleware,
    routerMiddleware(history)
  );

  const store = storeManager.createStore(preloadedState, compose(middlewares));

  sagaMiddleware.run(rootSaga);

  if (module.hot) {
    module.hot.accept('../reducers', () => {
      store.replaceReducer(rootReducer);
    });
  }

  return store;
};

const configureDevelopmentStore = preloadedState => {
  storeManager.registerReducers(staticReducers);
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const sagaMiddleware = createSagaMiddleware({
    context: {
      lang: 'en-US',
    },
    onError: error => {
      console.log('saga middlwae', error);
    },
  });

  const middlewares = applyMiddleware(
    sagaMiddleware,
    routerMiddleware(history),
    createLogger()
  );

  const store = storeManager.createStore(
    preloadedState,
    composeEnhancers(middlewares)
  );

  sagaMiddleware.run(rootSaga);

  if (module.hot) {
    module.hot.accept('../reducers', () => {
      store.replaceReducer(rootReducer);
    });
  }

  return store;
};

const isProduction = process.env.NODE_ENV === 'production';

export default isProduction
  ? configureProductionStore
  : configureDevelopmentStore;
